import { fetchFilteredCars } from "./actionsFilters";


export function setupPremiumSelectionActions() {

    let premiumSelectionExist = document.getElementById('premiumSelecionExist');
    let cardAlreadyExist = document.getElementById('card-premium-selection');

    if (premiumSelectionExist && !cardAlreadyExist) {


        var htmlFilter = `
        <div class="card-container" id="card-premium-selection">
            <div class="card">
                <div class="card-header" id="heading-premium_selecion">
                    <div class="clear" style="display: none;margin: auto;" id="clear_premium_selecion" data-clear-key="premium_selecion">
                        <i class="icon-fechar-regular"></i>
                        Limpar filtro
                    </div>
                </div>
    
                <div id="collapse-premium_selecion" class="collapse show" aria-labelledby="collapse-premium_selecion">
                    <div class="card-body">
                        <ul class="list-premium_selecion-wrapper used-model-filter-expanded-list">
                            <input type="hidden" name="optionals" value="" id="optionals">
                            <input name="premium_selecion" id="mini_next" type="radio" class="radio-clicked" data-name="mini_next" value="mini_next">
                            <label class="categories-label" for="mini_next">
                                <li class="categories-label-item">
                                    <svg width="100%" height="100%" viewBox="0 0 39 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
    <g transform="matrix(1,0,0,1,0,-10.503)">
        <path d="M0,14.908L12.279,14.908C13.059,13.691 14.084,12.726 15.356,12.011C16.627,11.297 18.007,10.94 19.497,10.94C20.986,10.94 22.369,11.298 23.645,12.015C24.921,12.732 25.945,13.697 26.715,14.908L39,14.908L37.784,16.124L27.385,16.124C27.599,16.585 27.761,17.066 27.871,17.568L36.375,17.568L35.159,18.785L28.059,18.785C28.08,19.099 28.09,19.337 28.09,19.499C28.09,19.661 28.08,19.9 28.059,20.214L33.731,20.214L32.514,21.43L27.871,21.43C27.761,21.937 27.599,22.416 27.385,22.867L31.064,22.867L29.832,24.083L26.715,24.083C25.945,25.296 24.921,26.264 23.645,26.985C22.369,27.706 20.986,28.066 19.497,28.066C18.007,28.066 16.627,27.707 15.356,26.989C14.084,26.27 13.059,25.301 12.279,24.083L9.168,24.083L7.959,22.867L11.631,22.867C11.419,22.416 11.259,21.937 11.15,21.43L6.51,21.43L5.278,20.214L10.949,20.214C10.928,19.9 10.918,19.661 10.918,19.499C10.918,19.337 10.928,19.099 10.949,18.785L3.864,18.785L2.632,17.568L11.15,17.568C11.259,17.066 11.419,16.585 11.631,16.124L1.216,16.124L0,14.908ZM12.746,16.649C12.359,17.556 12.165,18.506 12.165,19.499C12.165,20.492 12.359,21.443 12.746,22.35C13.133,23.256 13.655,24.039 14.311,24.697C14.967,25.355 15.747,25.878 16.651,26.267C17.555,26.656 18.504,26.85 19.497,26.85C20.489,26.85 21.439,26.656 22.346,26.267C23.252,25.878 24.034,25.355 24.69,24.697C25.346,24.039 25.868,23.256 26.259,22.35C26.649,21.443 26.844,20.492 26.844,19.499C26.844,18.506 26.649,17.556 26.259,16.649C25.868,15.742 25.346,14.961 24.69,14.305C24.034,13.65 23.252,13.128 22.346,12.739C21.439,12.35 20.489,12.156 19.497,12.156C18.504,12.156 17.555,12.35 16.651,12.739C15.747,13.128 14.967,13.65 14.311,14.305C13.655,14.961 13.133,15.742 12.746,16.649ZM13.646,21.43L14.406,21.43L14.384,18.549L15.304,21.43L16.149,21.425L17.052,18.564L17.052,21.43L17.863,21.43L17.863,17.568L16.721,17.567L15.741,20.647L14.742,17.571L13.646,17.568L13.646,21.43ZM18.737,21.43L19.542,21.43L19.542,17.568L18.737,17.568L18.737,21.43ZM20.416,21.43L21.191,21.43L21.191,18.648L22.733,21.43L23.668,21.43L23.668,17.568L22.908,17.568L22.908,20.366L21.366,17.568L20.416,17.568L20.416,21.43ZM24.557,21.43L25.347,21.43L25.347,17.568L24.557,17.568L24.557,21.43Z" style="fill-rule:nonzero;"/>
    </g>
</svg>
                                    <span class="categories-label-name">MINI NEXT - CERTIFICADOS</span>
                                </li>
                            </label>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        `;

        $('#main-filters').prepend(htmlFilter);

        syncUrlPremiumSelectionToFilter();

        startListenersPremiumSelection();

        // delete premiumSelectionExist
        premiumSelectionExist.classList.add('d-none');

    }

}

export function checkUrlParams() {
    const url = window.location.href;
    const premiumSelecionParam = url.includes('premium_selecion=')

    if (premiumSelecionParam) {
        syncUrlPremiumSelectionToFilter();
    }
}

function syncUrlPremiumSelectionToFilter() {
    const url = window.location.href;
    const premiumSelecionParam = url.includes('premium_selecion=');
    const clearPremiumSelecion = document.getElementById('clear_premium_selecion');
    const optionalsInput = document.getElementById('optionals');

    if (premiumSelecionParam) {

        const termo = url.split('premium_selecion=')[1];

        const termosConfig = {
            bmw_premium_selecion: 'bmw_premium_selecion',
            mini_next: 'mini_next',
            motorrad_premium_selecion: 'motorrad_premium_selecion'
        };

        if (termosConfig[termo]) {
            const id = termosConfig[termo];
            const input = document.getElementById(id);
            const label = document.querySelector(`label[for=${id}] li`);

            if (input) input.checked = true;
            if (label) label.classList.add('checked');

            if (optionalsInput) {
                optionalsInput.value = "MINI Next";
            }

            fetchFilteredCars();
        }

        if (clearPremiumSelecion) {
            clearPremiumSelecion.style.display = 'block';
        }

        syncPremiumSelectionAndOptionsInput();

    } else {

        const inputs = document.querySelectorAll('input[name="premium_selecion"]');
        const labels = document.querySelectorAll('label[for^="bmw_premium_selecion"], label[for^="mini_next"], label[for^="motorrad_premium_selecion"]');
        const optionalsInput = document.getElementById('optionals');

        optionalsInput.value = '';

        inputs.forEach(input => {
            input.checked = false;
            labels.forEach(label => {
                const labelChild = label.querySelector('li');
                labelChild.classList.remove('checked');
            });
        });

        if (clearPremiumSelecion) {
            clearPremiumSelecion.style.display = 'none';
        }
    }
}

function startListenersPremiumSelection() {
    listenSliders();
    listenPremiumSelectionInput();
    listenerPremiumSelectionClearButton();
}

function listenPremiumSelectionInput() {
    const inputs = document.querySelectorAll('input[name="premium_selecion"]');

    inputs.forEach(input => {
        input.addEventListener('change', () => {
            syncPremiumSelectionAndOptionsInput();
            fetchFilteredCars();
        });
    });
}

function listenerPremiumSelectionClearButton() {
    const clearPremiumSelecion = document.getElementById('clear_premium_selecion');

    if (clearPremiumSelecion) {
        clearPremiumSelecion.addEventListener('click', () => {
            clearUrlPremiumSelection();
            syncUrlPremiumSelectionToFilter();
            syncPremiumSelectionAndOptionsInput();
            fetchFilteredCars();
        });
    }
}

function syncPremiumSelectionAndOptionsInput() {
    const input = document.querySelector('input[name="premium_selecion"]:checked');
    const optionalsInput = document.getElementById('optionals');

    if (input && optionalsInput) {
        if (input.value == 'mini_next') {
            optionalsInput.value = "MINI Next";
        }
    } else if (optionalsInput) {
        optionalsInput.value = '';
    }

}

function clearUrlPremiumSelection() {
    const url = window.location.href.split('?')[0];
    window.history.pushState({}, '', url);
}